import { useAuth } from 'oidc-react'
import { isKiaOrg, parseAppCompanyID } from '@utils/kia'

/**
 * True when the signed-in user belongs to the Kia org (an Enterprise client with
 * reports only they see).
 *
 * Reads the org id from the live OIDC session on each render rather than at module
 * import, so anything gated on it appears as soon as the session loads instead of
 * waiting for a manual refresh. Falls back to the persisted session when the OIDC
 * profile has not been loaded yet.
 * IMPORTANT --> Can only be used within the AuthProvider component.
 */
export default function useIsKiaOrg(): boolean {
  const { userData } = useAuth()

  return isKiaOrg(parseAppCompanyID(userData?.profile?.organization_id))
}
